import * as z from 'zod/v4';

export const BOARD_PROPS_QP = ['WEIGHTEDQP', 'MODIFIEDQP', 'PARTIALQP'] as const;
export const quickPickEnum = z.enum(BOARD_PROPS_QP);

/**
 * TS Coupon QuickPick (PIX) type
 */
export type QuickPick = z.infer<typeof quickPickEnum>;

export const BOARD_PROPS = [...BOARD_PROPS_QP] as const;
export const boardPropsEnum = z.enum(BOARD_PROPS);
